import { StationAvatar } from '@app/components/base/stations/StationAvatar';
import { Station } from '@app/core/types/stations';
import { Box } from '@mui/material';
import { HTMLAttributes } from 'react';

type Props = {
  station: Station;
  /** Props injected by the Autocomplete for the option element (without the key). */
  liProps: HTMLAttributes<HTMLLIElement>;
};

/**
 * Single option row of StationsAutocomplete: station logo followed by its name.
 */
export function StationsAutocompleteOption({ station, liProps }: Props) {
  return (
    <Box component="li" {...liProps} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <StationAvatar stationId={station.id} station={station} size={20} />
      {station.name}
    </Box>
  );
}
